import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../core/shared/shared.module';
import { RcpReportRest } from './rcpreport.rest';
import { RcpReportComponent } from './rcpreport.component';
import { RcpReportRouting } from './rcpreport.routing';

@NgModule({
    imports: [
    CommonModule,
    RcpReportRouting,
    SharedModule
    ],
    exports: [
        ],
    declarations: [
        RcpReportComponent],
    providers: [RcpReportRest],
})
export class RcpReportModule { }